import { Link } from "react-router-dom";

export function CtaBanner() {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 pb-20">
      <div className="relative overflow-hidden rounded-2xl border border-slate-800 p-8 sm:p-12">
        <div className="dg-grid-bg absolute inset-0 opacity-60" />
        <div className="relative grid md:grid-cols-2 gap-6 items-center">
          <div>
            <span className="dg-eyebrow">Ready when you are</span>
            <h3 className="mt-2 text-2xl sm:text-3xl lg:text-4xl font-bold font-display tracking-tight">Book a phone or video session, open a ticket, or get an install quote.</h3>
            <p className="mt-3 text-slate-300">30 min $99.99 · 1 hour $149.99 · 1½-hour video call $249.99. Pick a time on David's calendar — nothing to pay until after your session. Ask Dr.Gadget tickets and installation quotes are free.</p>
          </div>
          <div className="flex flex-wrap gap-3 md:justify-end">
            <Link to="/book" className="dg-btn-primary rounded-full px-6 py-3 text-sm" data-testid="cta-book-btn">Book a Session</Link>
            <Link to="/ask?type=install" className="dg-btn-ghost rounded-full px-6 py-3 text-sm" data-testid="cta-install-btn">Installation quote</Link>
            <Link to="/ask" className="dg-btn-ghost rounded-full px-6 py-3 text-sm" data-testid="cta-ask-btn">Ask Dr.Gadget</Link>
          </div>
        </div>
      </div>
    </section>
  );
}
